/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Features_Note_2_TitleInputs */

const en_homepage_features_note_2_title = /** @type {(inputs: Homepage_Features_Note_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strengthen Long-term Retention`)
};

const es_homepage_features_note_2_title = /** @type {(inputs: Homepage_Features_Note_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortalece la retención a largo plazo`)
};

/**
* | output |
* | --- |
* | "Strengthen Long-term Retention" |
*
* @param {Homepage_Features_Note_2_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_features_note_2_title = /** @type {((inputs?: Homepage_Features_Note_2_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Features_Note_2_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_features_note_2_title(inputs)
	return en_homepage_features_note_2_title(inputs)
});